export function getCurrencySymbol(currency: string) {
  return (0)
    .toLocaleString('en-CA', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
    .replace(/\d/g, '')
    .trim();
}
